import { call, put, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import errorHandler from "common/errorHandler";
import * as actions from "./actions";

// No tenantid header — the tenant is determined server-side from the auth-token claims.

const promoteUrl = (businessAreaId, schemaId) => `${Endpoints.schemas}/api/v1/businessareas/${businessAreaId}/schemas/${schemaId}/promote`;

export function* promoteSchemaRequest(api, action) {
    try {
        const { businessAreaId, schemaId } = action.params;
        const result = yield call([api, api.put], promoteUrl(businessAreaId, schemaId), {});
        yield put(actions.promoteSchemaSuccess(result.data));
    } catch (error) {
        yield put(actions.promoteSchemaFailure(errorHandler(error, "Promote", "schema")));
    }
}

export function* demoteSchemaRequest(api, action) {
    try {
        const { businessAreaId, schemaId } = action.params;
        const result = yield call([api, api.delete], promoteUrl(businessAreaId, schemaId));
        yield put(actions.demoteSchemaSuccess(result.data));
    } catch (error) {
        yield put(actions.demoteSchemaFailure(errorHandler(error, "Demote", "schema")));
    }
}

export default function* ({ api }) {
    yield takeLatest(actions.PROMOTE_SCHEMA_REQUEST, promoteSchemaRequest, api);
    yield takeLatest(actions.DEMOTE_SCHEMA_REQUEST, demoteSchemaRequest, api);
}
